//export const URL='https://play-badminton-server-one.onrender.com'
//  export const URL = 'http://localhost:9000'
//export const URL = 'http://localhost:80'
//export const URL = 'http://104.40.78.187:9000'
//export const URL = 'https://pb-server.onrender.com'
//export const URL = 'https://pb-server-two.onrender.com' 
  export const URL = 'https://pbserveruat.onrender.com' // swaroop render new
//export const URL = 'https://playbadmintonbeappinsight-hghyhxg6f0ajbmf7.canadacentral-01.azurewebsites.net'